var _defs, _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: 1024,
    height: 1024,
    role: "img",
    "aria-label": "Dashboard",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "card",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF9128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF4C07"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tile",
    x1: 0,
    y1: 156,
    x2: 0,
    y2: 877.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FDF6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD8B1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "lift",
    x: "-8%",
    y: "-8%",
    width: "120%",
    height: "120%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 5,
    stdDeviation: 5,
    floodColor: "#8A3403",
    floodOpacity: 0.26
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    rx: 214.6,
    fill: "url(#card)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tiles",
    fill: "url(#tile)",
    filter: "url(#lift)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.7 156H460.8A31.7 31.7 0 0 1 492.5 187.7V390A107.3 107.3 0 0 1 385.2 497.3H182.9A31.7 31.7 0 0 1 151.2 465.6V292.5A136.5 136.5 0 0 1 287.7 156Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.2 156H736.3A136.5 136.5 0 0 1 872.8 292.5V465.6A31.7 31.7 0 0 1 841.1 497.3H638.8A107.3 107.3 0 0 1 531.5 390V187.7A31.7 31.7 0 0 1 563.2 156Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.9 536.4H385.2A107.3 107.3 0 0 1 492.5 643.7V846A31.7 31.7 0 0 1 460.8 877.7H287.7A136.5 136.5 0 0 1 151.2 741.2V568.1A31.7 31.7 0 0 1 182.9 536.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.8 536.4H841.1A31.7 31.7 0 0 1 872.8 568.1V741.2A136.5 136.5 0 0 1 736.3 877.7H563.2A31.7 31.7 0 0 1 531.5 846V643.7A107.3 107.3 0 0 1 638.8 536.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 516.9,
    r: 31.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "glyphs",
    fill: "url(#card)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.8 260.9L347.8 298.7L391.8 311.8L363.8 348.2L365.1 394.0L321.8 378.7L278.5 394.0L279.8 348.2L251.8 311.8L295.8 298.7Z",
    stroke: "url(#card)",
    strokeWidth: 14.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.7 382.8L665.6 336.5L697.3 358.4L760.7 292.6",
    fill: "none",
    stroke: "url(#card)",
    strokeWidth: 34.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.4 266.2L787 266.2L787 318.9Z",
    stroke: "url(#card)",
    strokeWidth: 15.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.6,
    y: 631.5,
    width: 146.3,
    height: 39,
    rx: 19.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.6,
    y: 690,
    width: 97.5,
    height: 39,
    rx: 19.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.6,
    y: 748.5,
    width: 146.3,
    height: 39,
    rx: 19.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 633.9,
    cy: 707,
    r: 24.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 699.7,
    cy: 707,
    r: 24.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.6,
    cy: 707,
    r: 24.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsc);
export default __webpack_public_path__ + "static/media/bsc.7753444c2ff339cf1f511a3563995fe5.svg";
export { ForwardRef as ReactComponent };